import {YearPeriod} from '@/common/interfaces/date';

const periodMonths: Record<YearPeriod, number[]> = {
	winter: [11, 0, 1],
	spring: [2, 3, 4],
	summer: [5, 6, 7],
	autumn: [8, 9, 10],
};

export function getYearPeriod(date = new Date()) {
	const month = date.getMonth();

	for (const [period, months] of Object.entries(periodMonths)) {
		if (months.includes(month)) {
			return period as YearPeriod;
		}
	}

	return 'winter';
}
